import { ContractSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const ReviseContractResponseSchema = oz.object({
  contract: ContractSchema,
}).openapi('ReviseContractResponse');

export type ReviseContractResponse = oz.infer<typeof ReviseContractResponseSchema>;